<template>
    <div class="user-intro" v-if="profile">
        <div class="title" v-html="$translate('INTRODUCE_MYSELF')" />
        <div class="text">{{ userIntro }}</div>
    </div>
</template>
<script>
export default {
    name: 'UserIntro',
    props: ['profile'],
    computed: {
        userIntro() {
            return (this.profile.intro || '').trim() || '-'
        },
    },
}
</script>
